<template lang="html">
  <div class="columns is-mobile">
    <Navigation v-model="openNavigation" />
    <div class="column is-two-fifths room-label has-text-white-bis">
      <a @click.stop="openNavigation = !openNavigation">
        <i class="fas fa-bars"></i>
        {{ spaceTitle }}
      </a>
    </div>
    <div class="column is-one-fifth has-text-centered has-text-weight-bold has-text-white-bis">
      {{ currentTime }}
    </div>
    <div class="column is-two-fifths has-text-right">
      <span
        style="cursor:pointer;"
        @click="openPicker" class="date has-text-white-bis"
      >
        {{ selectedDate.format('dddd, MMMM Do') }}
      </span>
      <div class="calendar-container">
        <Datepicker
          @selected="setDate"
          :value="selectedDate.toDate()"
          calendar-class="mvix-calendar"
          maximum-view="day"
          ref="datepicker"
        >
        </Datepicker>
      </div>
    </div>
  </div>
</template>

<script>

import moment from 'moment';
import { mapState, mapActions } from 'vuex';
import Datepicker from 'vuejs-datepicker';
import * as store from '../store/index';
import Navigation from './Navigation';

export default {
  components: { Navigation, Datepicker },

  data: () => ({
    currentTime: null,
    openNavigation: false,
  }),

  computed: {
    ...mapState({
      spaceTitle: state => state.space.title,
      selectedDate: 'selectedDate',
    }),
  },

  created() {
    this.currentTime = moment().format('LT');
    setInterval(() => { this.currentTime = moment().format('LT'); }, 60 * 1000);
    // Resets current date in datepicker and date title to current every 1 hour
    setInterval(() => { store.default.commit('setDate', moment()); }, 1 * 10 * 1000);
  },

  methods: {
    ...mapActions(['setDate']),

    closeCalendar(event) {
      if (this.$refs.datepicker && !this.$refs.datepicker.$el.contains(event.target)) {
        this.$refs.datepicker.close();
      }
    },

    openPicker() {
      document.removeEventListener('click', this.closeCalendar, false);
      this.$refs.datepicker.showCalendar();

      setTimeout(() => {
        document.addEventListener('click', this.closeCalendar, false);
      }, 100);
    },
  },
};
</script>

<style lang="scss" scoped>
  div.column {
    font-size: 1.8em;
  }

  div.calendar-container {
    font-size: 1rem;
  }

  div.room-label {
    height: 37px;
    opacity: 0.9;

    a {
      color: #FFFFFF;

      i {
        padding-right: 5px;
      }
    }
  }

  span.date {
    height: 27px;
    opacity: 0.9;
    text-align: right;
  }

  .calendar-container {
    display: flex;
    justify-content: flex-end;
  }

  @media only screen and (max-width: 900px) {
    div.column {
      font-size: 1.2em;
    }
  }
</style>

<style lang="scss">
  .calendar-container .mvix-calendar.vdp-datepicker__calendar {
    position: relative;
    border: none;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 0 5px  #25252580;

    input {
      display: none;
    }

    .calendar-header {
      background-color: #3971D0;
      padding: 10px;

      .year {
        font-size: 12px;
      }
    }

    .cell{
      height:auto;
    }

    .cell.selected,
    .cell:not(.blank):not(.disabled).day:hover{
      border-radius: 50%;
    }
  }

  .vdp-datepicker {
    input {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue